import React from "react";
import { EXCHANGE_COST_TYPE, EXCHANGE_ORDER_STATUS } from "~/constants";
import { formatAmountWithCurrency, isNilOrEmptyString } from "~/utils";
import ExternalLink from "~/components/ExternalLink.jsx";
import AvatarAndItemName from "~/components/items/AvatarAndItemName.jsx";
import { ExchangeStatusChip } from "~/components/chips/statusChips/ExchangeStatusChip.jsx";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { CustomChip } from "~/components/chips/CustomChip.jsx";
import { faRotate } from "@fortawesome/pro-regular-svg-icons";
import SpecialItemLine from "./_components/SpecialItemLine";
import CollapsibleReturnPart from "./_components/CollapsibleReturnPart";
import LineDivider from "rylak-common/src/components/divider/LineDivider";
import { formatReadableDateAndTimeShort } from "rylak-common";
import { getOrderCurrencyCode } from "~/cores/orderCore";
import { OpenOrderInShopButton } from "~/components/ecom/OpenOrderInEcomButton.jsx"; //

function exchangePrice(exchangeOrder) {
    if (exchangeOrder?.costType === EXCHANGE_COST_TYPE.FREE) {
        return "Free";
    } else if (exchangeOrder?.costType === EXCHANGE_COST_TYPE.CALCULATED_SHIPPING && isNilOrEmptyString(exchangeOrder?.chargedAmount)) {
        return "Calculated later";
    } else {
        return formatAmountWithCurrency(exchangeOrder?.chargedAmount, {
            currency: getOrderCurrencyCode(exchangeOrder),
        });
    }
}

export default function ExchangeCard(props) {
    const { exchangeOrder, appProps, onUpdate } = props;

    const paymentLink = exchangeOrder?.status === EXCHANGE_ORDER_STATUS.DRAFT_ORDER_CREATED ? exchangeOrder?.paymentUrl : null;
    const showCompletedOrderLink = exchangeOrder?.status === EXCHANGE_ORDER_STATUS.ORDERED && exchangeOrder?.foreignCompletedOrderId;

    return (
        <CollapsibleReturnPart
            appProps={appProps}
            headerIcon={faRotate}
            headerTitle={"Exchange order"}
            headerChip={
                exchangePrice(exchangeOrder) && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <CustomChip tooltipTitle={"Exchange price"} label={exchangePrice(exchangeOrder)} />
                        {showCompletedOrderLink && <OpenOrderInShopButton foreignOrderId={exchangeOrder?.foreignCompletedOrderId} order={exchangeOrder?.order} />}
                    </div>
                )
            }
            statusChips={[<ExchangeStatusChip key={"1"} size={"small"} status={exchangeOrder?.status} />]}
            dateChip={exchangeOrder?.orderedAt && <CustomChip tooltipTitle={"Ordered at"} label={formatReadableDateAndTimeShort({ dateTime: exchangeOrder?.orderedAt })}></CustomChip>}
            optionsEntity={exchangeOrder}
            onUpdate={onUpdate}
        >
            <div>
                {paymentLink && (
                    <div>
                        <div
                            style={{
                                width: "fit-content",
                                marginBottom: "15px",
                            }}
                        >
                            <TurnrGrid container spacing={1}>
                                <TurnrGrid item xs={12}>
                                    <ExternalLink href={paymentLink} style={{ fontSize: "13px" }} iconSize={10} text={"Payment link"} />
                                </TurnrGrid>
                            </TurnrGrid>
                        </div>
                        <LineDivider className={"mb2"}></LineDivider>
                    </div>
                )}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gridGap: "20px",
                    }}
                >
                    {exchangeOrder?.items?.map((item, index) => {
                        let orderItem = item?.orderItem;
                        let exchangeVariant = item?.productVariant;
                        return (
                            <div key={orderItem?.id}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "relative",
                                    }}
                                >
                                    <AvatarAndItemName orderItem={orderItem} shopLink={false} />
                                    <SpecialItemLine height={"calc(100% - 15px)"} left={22} top={54} />
                                </div>
                                <div
                                    style={{
                                        marginLeft: "55px",
                                        marginTop: "15px",
                                        position: "relative",
                                    }}
                                >
                                    <SpecialItemLine width={"20px"} left={-33} top={31} />
                                    <AvatarAndItemName productVariant={exchangeVariant} shopLink={false} />
                                </div>
                                {index !== exchangeOrder?.items?.length - 1 && <LineDivider style={{ marginTop: "15px" }} />}
                            </div>
                        );
                    })}
                </div>
            </div>
        </CollapsibleReturnPart>
    );
}
